export default __webpack_public_path__ + "static/media/CopyIcon.073b9f66.svg";